export default "__VITE_ASSET__D165WS3j__"